import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import successGif from "../../../assets/success.gif";
import { toast } from "react-toastify";

const CreateBankModal = ({ show, onClose, onCreate }) => {
  const [formData, setFormData] = useState({
    name: "",
    iban: "",
    bic: "",
    rib: "",
  });

  const [showSuccess, setShowSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Ensure status is explicitly false for creation
      await onCreate({ ...formData, status: false });

      setShowSuccess(true);

      // Delay closing modal to allow success animation to show
      setTimeout(() => {
        setShowSuccess(false); // reset success
        onClose(); // close modal
        setFormData({
          // reset form (after modal is closed to avoid flicker)
          name: "",
          iban: "",
          bic: "",
          rib: "",
        });
      }, 2000);
    } catch (error) {
      console.error("Erreur lors de la création de la banque :", error);
      const errorMessage =
        error?.data?.message[0] || error?.message || "Erreur inconnue";

      toast.error(`Erreur lors de la création de la banque: ${errorMessage}`);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered backdrop="static">
      <Modal.Header closeButton>
        {!showSuccess && <Modal.Title>Ajouter une nouvelle banque</Modal.Title>}
      </Modal.Header>

      <Modal.Body>
        {showSuccess ? (
          <div className="text-center animate__animated animate__fadeIn">
            <img
              src={successGif}
              alt="Success"
              style={{ width: "100px", height: "100px" }}
              className="mb-3"
            />
            <h5 className="text-success">Créée avec succès !</h5>
          </div>
        ) : (
          <Form
            onSubmit={handleSubmit}
            className="animate__animated animate__fadeIn">
            <Form.Group controlId="bankName" className="mb-3">
              <Form.Label>Nom de la banque</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Ex: Banque de France"
                required
              />
            </Form.Group>

            <Form.Group controlId="iban" className="mb-3">
              <Form.Label>IBAN</Form.Label>
              <Form.Control
                type="text"
                name="iban"
                value={formData.iban}
                onChange={handleChange}
                placeholder="Ex: FR5910006035183598478831"
              />
            </Form.Group>

            <Form.Group controlId="bic" className="mb-3">
              <Form.Label>BIC</Form.Label>
              <Form.Control
                type="text"
                name="bic"
                value={formData.bic}
                onChange={handleChange}
                placeholder="Ex: BNTETNTT"
              />
            </Form.Group>

            <Form.Group controlId="rib" className="mb-3">
              <Form.Label>RIB</Form.Label>
              <Form.Control
                type="text"
                name="rib"
                value={formData.rib}
                onChange={handleChange}
                placeholder="Ex: 10006035183598478831"
              />
            </Form.Group>

            <div className="d-flex justify-content-end">
              <Button variant="secondary" onClick={onClose} className="me-2">
                Annuler
              </Button>
              <Button variant="primary" type="submit">
                Enregistrer
              </Button>
            </div>
          </Form>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default CreateBankModal;
